<template>
  <div>
    <self-back :pageHeaderList="[{'name':'返点比例配置'}]"></self-back>
    <div class="content" v-loading='loading'>
      <div>
        <button class="addaccountButton" @click="addaccountEvent">+ 添加返点比例配置</button>
        <el-date-picker style="width:160px;margin-left:10px;" v-model="screenMonth" :clearable='true' type="month" size="mini" value-format="yyyy-MM" placeholder="月份筛选">
        </el-date-picker>
        <el-select class="input" v-model="keyword" clearable size='mini' filterable placeholder="媒体名称">
          <el-option v-for="(item,index) in mediaList" :key="index" :label="item.media_name" :value="item.media_name">
          </el-option>
        </el-select>
      </div>
      <el-table class="table" :header-cell-style="{background:'#f5f7fa'}" :data="accountList" border :max-height="tableMaxHeight">
        <el-table-column prop="rebate_format" label="返点比例" align='center' width="160"></el-table-column>
        <el-table-column prop="month_format" align='center' label="时间"></el-table-column>
        <el-table-column prop="media_name" align='center' label="媒体名称"></el-table-column>
        <el-table-column prop="company" align='center' label="签约公司"></el-table-column>
        <el-table-column align='center' label="是否确认">
          <template slot-scope="scope">
            {{scope.row.is_confirm==1?'是':'否'}}
          </template>
        </el-table-column>
        <el-table-column align='center' label="操作">
          <template slot-scope="scope">
            <button :disabled="!canOperateRebate || scope.row.is_confirm==1" @click="modifyaccountEvent(scope.row)">修改</button>
            <button style="background:#FF9B3B" :disabled="!canOperateRebate" @click="confirmEvent(scope.row)" v-if="scope.row.is_confirm!=1">确认</button>
            <button v-if="scope.row.del_enable==1" style="background:#FC726D" @click="deleteaccountFlagEvent(scope.row)">删除</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paginationBox">
        <el-pagination small background @current-change="handleCurrentChange" :current-page="page" :page-size="page_size" layout="total, prev, pager, next, jumper" :total="total" />
      </div>
    </div>
    <!-- 添加账号 -->
    <el-dialog :title="isEdit?'修改返点比例配置':'添加返点比例配置'" :visible.sync="addaccountFlag" width="500px" :close-on-click-modal='false' center>
      <div class="dialogBox">
        <div class="dialogitem" style="margin-bottom: 20px;">
          <label><em>*</em>返点比例：</label>
          <el-input placeholder="请输入返点比例" style="width:53%" v-model.trim="accountName" size='small' @input="(val)=>{accountName=accountName.replace(/[^\d|.]/g,'')}" clearable>
          </el-input>%
        </div>
        <div class="dialogitem">
          <label><em>*</em>时间：</label>
          <el-date-picker :disabled="isEdit?true:false" style="width:56%" v-model="timeMonth" type="month" size="mini" value-format="yyyy-MM" placeholder="选择时间">
          </el-date-picker>
        </div>
        <div class="dialogitem">
          <label><em>*</em>媒体名称：</label>
          <el-select style="width:56%" v-model="media_name" :disabled="isEdit?true:false" clearable size='mini' filterable placeholder="媒体名称">
            <el-option v-for="(item,index) in mediaList" :key="index" :label="item.media_name" :value="item.media_name">
            </el-option>
          </el-select>
        </div>
        <div class="dialogitem" style="margin-bottom: 20px;">
          <label><em>*</em>签约公司:</label>
          <el-select v-model="company" :disabled="isEdit?true:false" style="width:56%" size='mini' filterable placeholder="请选择签约公司">
            <el-option v-for="(item,index) in signCompanyList" :key="index" :label="item.company" :value="item.company">
            </el-option>
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAddaccount" size="mini">取 消</el-button>
        <el-button type="primary" @click="addaccountYes" size="mini">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      addaccountFlag: false,
      deleteaccountFlag: false,
      accountList: [],
      accountName: '',
      page: 1,
      page_size: 20,
      total: 0,
      loading: false,
      isEdit: false,
      timeMonth: '',
      vebateId: '',
      type: 0,
      editType: '',
      media_name: '',
      screenMonth: '',
      keyword: '',
      mediaList: [],
      signCompanyList: [],
      company: '',
      userInfo: {}
    }
  },
  computed: {
    tableMaxHeight () {
      return window.innerHeight - 260
    },
    canOperateRebate () {
      return [13, 15, 19].includes(Number(this.userInfo.role_id))
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo') || '{}')
    this.costCompanys()
    this.getMediaList()
    this.accountsListEvent(1)
  },
  methods: {
    addaccountEvent () {//点击添加账号按钮
      this.addaccountFlag = true;
      this.isEdit = false;
      this.editType = ''
      this.media_name = ''
      this.company = ''
    },
    deleteaccountFlagEvent (data) {//删除账号
      this.$confirm('确定要删除该配置?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.URL.BASEURL + this.URL.rebateDel, {
          id: data.id,
          type: this.getRowType(data),
          media_name: data.media_name
        }).then((res) => {
          var res = res.data;
          if (res && res.errno == 0) {
            this.accountsListEvent(this.page)
          } else {
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
        })
      }).catch(() => {
      });
    },
    handleCurrentChange (val) {
      this.accountsListEvent(val)
    },
    accountsListEvent (page) {
      this.loading = true;
      this.page = page
      this.$axios.get(this.URL.BASEURL + this.URL.rebateList, {
        params: {
          page: page,
          page_size: this.page_size,
          type: this.type,
          month: this.screenMonth,
          media_name: this.keyword
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.accountList = res.rst.data;
          this.total = res.rst.pageInfo.total;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    confirmEvent (data) {
      if (!this.canOperateRebate) {
        this.$message({
          message: '当前角色无操作权限',
          type: 'warning'
        })
        return
      }
      this.$confirm('确定进行此操作？', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$axios.post(this.URL.BASEURL + this.URL.rebateEdit, {
          rebate: data.rebate_format.replace(/\%/g, ''),
          month: data.year + '-' + data.month,
          id: data.id,
          media_name: data.media_name,
          company: data.company,
          type: this.getRowType(data),
          is_confirm: 1
        }).then((res) => {
          var res = res.data;
          this.loading = false
          if (res && res.errno == 0) {
            this.$message({
              message: '确认成功！',
              type: 'success'
            })
            this.accountsListEvent(this.page)
            this.cancelAddaccount()
          } else {
            this.$message({
              message: res.err,
              type: 'warning'
            })
            if (res && res.errno == 6017) {
              this.accountsListEvent(this.page)
              this.cancelAddaccount()
            }
          }
        }).catch(() => {
          this.loading = false
        })
      })
    },
    addaccountYes () {//添加账号
      if (this.isEdit && !this.canOperateRebate) {
        this.$message({
          message: '当前角色无操作权限',
          type: 'warning'
        })
        return
      }
      if (this.accountName == '') {
        this.$message({
          message: '请输入返点比例',
          type: 'fail'
        })
        return
      }
      if (this.timeMonth == '') {
        this.$message({
          message: '请选择配置日期',
          type: 'fail'
        })
        return
      }
      if (this.media_name == '') {
        this.$message({
          message: '请输入媒体名称',
          type: 'fail'
        })
        return
      }
      if (this.company == '') {
        this.$message({
          message: '请选择签约公司',
          type: 'fail'
        })
        return
      }
      const submitType = this.isEdit ? this.editType : this.getRebateTypeByMediaName(this.media_name)
      if (this.isEdit) {//编辑
        this.$axios.post(this.URL.BASEURL + this.URL.rebateEdit, {
          rebate: this.accountName,
          month: this.timeMonth,
          id: this.vebateId,
          media_name: this.media_name,
          company: this.company,
          type: submitType
        }).then((res) => {
          var res = res.data;
          if (res && res.errno == 0) {
            this.$message({
              message: '修改成功！',
              type: 'success'
            })
            this.accountsListEvent(this.page)
            this.cancelAddaccount()
          } else {
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
        })
      } else {
        this.$axios.post(this.URL.BASEURL + this.URL.rebateAdd, {
          rebate: this.accountName,
          month: this.timeMonth,
          type: submitType,
          media_name: this.media_name,
          company: this.company
        }).then((res) => {
          var res = res.data;
          if (res && res.errno == 0) {
            this.$message({
              message: '添加成功！',
              type: 'success'
            })
            this.accountsListEvent(this.page)
            this.cancelAddaccount()
          } else {
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
        })
      }
    },
    cancelAddaccount () {//取消添加账号
      this.addaccountFlag = false;
      this.accountName = '';
      this.timeMonth = '';
      this.vebateId = '';
      this.editType = '';
      this.media_name = '';
      this.company = '';
    },
    modifyaccountEvent (data) {//修改账号
      if (!this.canOperateRebate) {
        this.$message({
          message: '当前角色无操作权限',
          type: 'warning'
        })
        return
      }
      if (data.is_confirm == 1) {
        this.$message({
          message: '已确认配置不允许修改',
          type: 'warning'
        })
        return
      }
      this.accountName = data.rebate_format.replace(/\%/g, '');
      this.timeMonth = (data.month_format.replace(/\年/g, '-')).replace(/\月/g, '');
      this.vebateId = data.id;
      this.editType = this.getRowType(data);
      this.isEdit = true;
      this.addaccountFlag = true;
      this.media_name = data.media_name
      this.company = data.company
    },
    getRowType (data) {
      return data && data.type ? data.type : this.getRebateTypeByMediaName(data && data.media_name)
    },
    getRebateTypeByMediaName (mediaName) {
      return String(mediaName || '').trim() === '流量助推' ? 2 : 1
    },
    getMediaList () {
      this.$axios.get(this.URL.BASEURL + this.URL.mediaList, {
        params: {
          page: 1,
          page_size: 999,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.mediaList = res.rst.data;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    costCompanys () {
      this.$axios.get(this.URL.BASEURL + this.URL.signCompanyList, {
        params: {
          page: 1,
          pagesize: 1000
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.signCompanyList = res.rst.data;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
  },
  watch: {
    screenMonth () {
      this.accountsListEvent(1)
    },
    keyword () {
      this.accountsListEvent(1)
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 2px 6px 0px rgba(32, 38, 82, 0.1);
  padding: 15px 15px 0;
  .addaccountButton {
    height: 30px;
    background: #5b7bfe;
    border-radius: 4px;
    color: #ffffff;
    font-size: 13px;
    border: none;
    padding: 0 10px;
  }
  .table {
    margin-top: 15px;
    button {
      min-width: 48px;
      height: 22px;
      background: #5b7bfe;
      border-radius: 4px;
      color: #ffffff;
      font-size: 12px;
      border: none;
      padding: 0 6px;
    }
    button:disabled {
      opacity: 0.45;
      cursor: not-allowed;
    }
  }
}
.dialogitem {
  margin-bottom: 20px;
  &:last-of-type {
    margin-bottom: 0;
  }
  label {
    display: inline-block;
    width: 150px;
    color: #202652;
    font-size: 14px;
    line-height: 20px;
    em {
      color: red;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/disposeAdmin/vebateRatio.vue